import R from 'ramda';
import { createSelector } from 'reselect';
import deprecated from '../deprecated';

import { param } from './utils';

const selectMembershipStoreRoot = root => root.membership;

// (root, id) => Membership
export const getMembership = createSelector(
    selectMembershipStoreRoot,
    param(1),
    (state, id) => state[id]
);

// (root) => [ ...Membership ]
export const selectAllMemberships = createSelector(
    selectMembershipStoreRoot,
    R.values
);

// (root, sectionId) => Membership
export const getBySection = createSelector(
    selectAllMemberships,
    param(1),
    (allMemberships, sectionId) => {
        return R.find(m => m.section_id == sectionId, allMemberships);
    }
);

const selectAllLastPages = createSelector(
    selectAllMemberships,
    allMemberships => {
        return R.reduce(
            (memo, membership) => {
                return {
                    ...memo,
                    ...membership.last_pages,
                };
            },
            {},
            allMemberships
        );
    }
);

export const selectLastPageRead = createSelector(
    selectAllLastPages,
    param(1),
    (allLastPages, contentId) => allLastPages[contentId] || 0
);
export const getLastPageRead = deprecated(
    selectLastPageRead,
    `Use selectLastPageRead instead`
);



// WEBPACK FOOTER //
// ./src/selectors/membership.js